module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-ExtraLightItalic.408d0e6.woff";